import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'

const Container = styled.ul`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  list-style: none;
  margin: -30px 0 0 0;

  li {
    font-size: 0;
    margin: 30px 0 0 0;
    min-width: 160px;
    text-align: center;
  }

  img {
    margin: 0;
  }
`

const ImageStrip = ({ images }) => (
  <Container>
    {images.edges.map((img, index) => {
      return (
        <li key={index}>
          <img alt={img.node.name} src={img.node.logo.publicURL} />
        </li>
      );
    })}
  </Container>
)

ImageStrip.propTypes = {
  images: PropTypes.object.isRequired
}

export default ImageStrip



// WEBPACK FOOTER //
// ./src/components/ImageStrip/index.js